import { TOption, TOptionKeys } from "./forms.config";

export const toOptions = <
  TValueKey extends PropertyKey,
  TLabelKey extends PropertyKey,
  TItem extends Readonly<Record<TValueKey | TLabelKey, string>>,
>(
  array: readonly TItem[],
  { value, label }: TOptionKeys<TValueKey, TLabelKey>,
): TOption[] => array.map((arrayItem) => ({
  value: arrayItem[value],
  label: arrayItem[label],
}));
